import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "", as = "div", ...rest }) => {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <span className={`mask-line ${className}`}>
      <motion.span
        initial={reduce ? false : { y: "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1.05, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};
